module.exports = __webpack_public_path__ + "img/icon-close.45ae10f9.svg";